import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FMessageDialogDataInterface } from './f-message-dialog-service/f-message-dialog.service';

@Component({
  selector: 'app-f-message-dialog',
  templateUrl: './f-message-dialog.component.html',
  styleUrls: ['./f-message-dialog.component.scss']
})
export class FMessageDialogComponent {

  public get getMessages() {
    const messages = Array.isArray(this.data.message) ? this.data.message : [this.data.message];
    return messages.map(v => {
      if (typeof v === 'string') return { message: v, style: '' };
      else return {
        message: v.message,
        style: v.style || '',
        tag: v.tag ?? '',
        href: v.href ?? ''
      };
    })
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: FMessageDialogDataInterface,
  ) { }

  public onClose() {
    if (this.data.onClose) this.data.onClose();
  }

}
